if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"src_AdminPanel_pages_Auto_Auto_tsx-src_AdminPanel_shared_ui_adaptive-cards_adaptive-cards_scs-54c298": 1,
"src_AdminPanel_pages_Auto_BrandInfo_BrandInfo_tsx-src_AdminPanel_shared_ui_adaptive-cards_ada-f8d4c0": 1,
"src_AdminPanel_pages_Auto_ModelInfo_ModelInfo_tsx-src_AdminPanel_shared_ui_adaptive-cards_ada-a5d107": 1,
"src_AdminPanel_pages_BlackList_BlackList_tsx": 1,
"src_AdminPanel_pages_Clients_ClientInfoPage_ClientInfoPage_tsx": 1,
"src_AdminPanel_pages_ExternalServices_ExternalServices_tsx": 1,
"src_AdminPanel_pages_Modules_ModuleInfo_ModuleInfo_tsx": 1,
"src_AdminPanel_pages_Partners_Partners_tsx-src_AdminPanel_shared_ui_adaptive-cards_adaptive-c-4b7ab0": 1,
"src_AdminPanel_pages_Products_ProductInfo_ProductInfo_tsx": 1,
"src_AdminPanel_pages_Products_Products_tsx": 1,
"src_AdminPanel_pages_Reports_Reports_tsx": 1,
"src_AdminPanel_pages_SystemSettings_SystemSettings_tsx-src_AdminPanel_shared_ui_adaptive-card-72027a": 1,
"src_AdminPanel_pages_Users_UserInfoPage_UserInfoPage_tsx": 1,
"src_AdminPanel_pages_Users_Users_tsx-src_AdminPanel_shared_ui_adaptive-cards_adaptive-cards_s-3915cc": 1,
"src_media_images_broken-image_png-src_shared_constants_contracts_ts-src_shared_features_index_ts": 1,
"src_pages_Assessments_Assessments_tsx": 1,
"src_pages_ClientContractAppeal_ClientContractAppeal_tsx": 1,
"src_pages_ClientContractAppeals_ClientContractAppeals_tsx": 1,
"src_pages_ClientInfo_ClientInfo_tsx-src_media_icons_refresh_svg_react": 1,
"src_pages_Clients_Clients_tsx": 1,
"src_pages_ContractInfo_ContractInfo_tsx": 1,
"src_pages_ContractInfo_entities_contract-termination_index_ts": 1,
"src_pages_Contracts_Contracts_tsx": 1,
"src_pages_LeasedPropertyInfo_LeasedPropertyInfo_tsx": 1,
"src_pages_LeasedProperty_LeasedProperty_tsx": 1,
"src_pages_LeasingScoringCreate_LeasingScoringCreate_tsx": 1,
"src_pages_LeasingScoringRequest_LeasingScoringRequest_tsx": 1,
"src_pages_LeasingScoring_LeasingScoring_tsx": 1,
"src_pages_Reports_Reports_tsx": 1,
"src_pages_Statistics_Statistics_tsx": 1,
"src_pages_VehicleAssessment_VehicleAssessment_tsx": 1,
"vendors-node_modules_pnpm_jodit-react_5_3_21_react-dom_19_2_4_react_19_2_4__react_19_2_4_node-2c033e": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

// no prefetch
// no preload